import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import BorderRadius from "%/dynamic-component-editor/options/border-radius";
import Visible from "%/dynamic-component-editor/options/visible";
import Opacity from "%/dynamic-component-editor/options/opacity";
import Rotate from "%/dynamic-component-editor/options/rotate";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import Blur from "%/dynamic-component-editor/options/blur";
import ZIndex from "%/dynamic-component-editor/options/zindex";

export default class AppearanceOptions extends BaseOptionsBundle {

  optionTitle = "Appearance";
  static optionClassName = "i-dynamic-appearance";
  inspectorToolGroup = "appearance";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.APPEARANCE_TOOL_SET,
  };

  constructor(values = {}, hideFromInspector = {}, isOverridable = undefined) {
    super(values, [
      new Visible(undefined, hideFromInspector["visible"] ?? false),
      new Opacity(undefined, hideFromInspector["opacity"] ?? false),
      new Rotate(undefined, hideFromInspector["rotate"] ?? false),
      new Blur(undefined, hideFromInspector["blur"] ?? false),
      new BorderRadius(undefined, hideFromInspector["border-radius"] ?? true),
      new ZIndex(undefined, hideFromInspector["z-index"] ?? false),
    ]);

    this.isOverridable = isOverridable !== false;
  }
}
